import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogActions } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-eos-metrics-dialog',
    templateUrl: './eos-metrics-dialog.component.html',
    styleUrls: ['./eos-metrics-dialog.component.scss'],
    imports: [MatDialogTitle, MatDialogActions, MatButton]
})
export class EosMetricsDialogComponent implements OnInit {

  shift:any;

  displayedColumns: string[] = ["ObjectID", "Target", "Actual"];

  constructor(
    public dialogRef: MatDialogRef<EosMetricsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public inData: any
  ) {
    this.shift = this.inData.Shift;


   }

  ngOnInit(): void {
    console.log("Shift info!!", this.shift);
  }

  onNoClick():void {
    console.log("Close");
    this.dialogRef.close();
  }

}
